import { render } from "./MobileBottomPromo.vue?vue&type=template&id=79836026&scoped=true"
import script from "./MobileBottomPromo.vue?vue&type=script&lang=js"
export * from "./MobileBottomPromo.vue?vue&type=script&lang=js"

import "./MobileBottomPromo.vue?vue&type=style&index=0&id=79836026&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79836026"]])

export default __exports__